import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import * as React from 'react';
import { api, file } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import '../lazy-image/legacy-lazy-image/index.js';
import { CircleLazyImage } from '../lazy-image/lazy-image/index.js';
import styles from './style/main.module.scss.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
// eslint-disable-next-line @typescript-eslint/no-magic-numbers

var DEFAULT_RATIO = 100 / 76;
/**
 * 头像组件
 */

var Avatar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var src = props.src,
      avatarClassName = props.avatarClassName,
      avatarDefaultImage = props.avatarDefaultImage,
      badge = props.badge,
      className = props.className,
      frameClassName = props.frameClassName,
      frameSrc = props.frameSrc,
      _props$widthRatioOfFr = props.widthRatioOfFrameToAvatar,
      widthRatioOfFrameToAvatar = _props$widthRatioOfFr === void 0 ? DEFAULT_RATIO : _props$widthRatioOfFr;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isFrameLoadSucceed = _React$useState2[0],
      setFrameLoadSucceed = _React$useState2[1];

  var _React$useState3 = React.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      realFrameUrl = _React$useState4[0],
      setRealFrameUrl = _React$useState4[1];

  var renderAvatar = function renderAvatar() {
    var avatarProps = _objectSpread({
      src: src
    }, avatarDefaultImage && {
      defaultImage: avatarDefaultImage
    }); // TODO: 后续如果有方形头像的场景，可在此处进行拓展


    return /*#__PURE__*/React.createElement(CircleLazyImage, _objectSpread(_objectSpread({}, avatarProps), {}, {
      className: classNames(avatarClassName, styles['avatar-image'])
    }));
  }; // TODO: 统一徽章位置和大小后，renderBadge 支持 badge 渲染预设样式（goldenVip、blueVip 和 live）


  var renderBadge = function renderBadge() {
    if ( /*#__PURE__*/React.isValidElement(badge)) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles['avatar-badge']
      }, badge);
    }

    return null;
  };

  React.useEffect(function () {
    if (frameSrc) {
      var frameUrl = api.replaceToFreeFlowUrl(file.fallbackImage(frameSrc)); // 更新处理后的头像框 url

      setRealFrameUrl(frameUrl); // 判断处理后的头像框 url 是否加载成功，加载成功后再显示头像框

      var img = new Image();
      img.src = frameUrl;

      img.onload = function () {
        setFrameLoadSucceed(true);
      };
    } else {
      setRealFrameUrl('');
      setFrameLoadSucceed(false);
    }
  }, [frameSrc]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['avatar-container'], className),
    ref: ref
  }, renderAvatar(), !!realFrameUrl && isFrameLoadSucceed && /*#__PURE__*/React.createElement("img", {
    src: realFrameUrl,
    className: classNames(styles['avatar-frame'], frameClassName),
    style: frameClassName ? undefined : {
      width: "".concat(100 * widthRatioOfFrameToAvatar, "%")
    }
  }), renderBadge());
});

export { Avatar };
